import { useContext } from "react";

import { Language } from "@holibob-packages/language";

import { LocalizationContext } from "../contexts/LocalizationProvider";

export function useLanguage(): Language {
    return useContext(LocalizationContext).language;
}
